export default function formJobScheme(jobs) {
  return jobs
    .reduce((jobs, { assign }) => assign(jobs), {})
}
